import React from 'react'
import { Form, Button, Dropdown } from "react-bootstrap";
import Col from "react-bootstrap/Col"
import { Link } from "gatsby"

const ButtonField = ({type, name, value, fieldClass, step,handlechange,handlechange2}) => (
	<>
		<Button variant="" type={type}  className={`${fieldClass ? fieldClass : "btn btn-fill-primary w-100"}`}>
			{name}
			<i className="icon-right"></i>
		</Button>
		<div className="contact-terms">By clicking Submit Enquiry, you agree to our <Link to="/terms-and-conditions/">Terms</Link> and <Link to="/privacy/">Privacy Policy.</Link></div>

	</>
);

export default ButtonField;